import React, { useContext, useState } from 'react'
import TechnologySolution from '../../../../assets/backgrounds/technology-solution.svg'
import ReimaginedSolution from '../../../../assets/backgrounds/reimagined-solution.svg'
import HorizonsSolution from '../../../../assets/backgrounds/horizons-solution.svg'
import { FormattedMessage } from 'react-intl'
import SolutionCard from './components/SolutionCard'
import { Waypoint } from 'react-waypoint'
import SectionWithTag from '../../../../components/SectionWithTag'
import PaddingContext from '../../../../utils/PaddingContext'

const id = 'page.homepage.era'

const solutionCards = [
    {
        id: `${id}.platform`,
        link: '/technology',
        className: 'bg-green-light',
        background: {
            component: TechnologySolution,
            className: 'mix-blend-difference',
        },
    },
    {
        id: `${id}.far`,
        link: '/applications',
        className: 'bg-sand',
        background: {
            component: HorizonsSolution,
            props: {
                style: {
                    filter: 'invert(1) brightness(1.5)',
                },
            },
        },
    },
    {
        id: `${id}.reimagined`,
        link: '/partnerships',
        className: 'bg-purple-light',
        background: {
            component: ReimaginedSolution,
            className: 'mix-blend-multiply',
            props: {
                style: {
                    filter: 'invert(1) brightness(1.5)',
                },
            },
        },
    },
]

const NewEra = () => {
    const { padding } = useContext(PaddingContext)
    const [visible, setVisible] = useState(false)

    return (
        <div className='pt-14 md:pt-30 bg-white border-t border-black/10 relative'>
            <SectionWithTag
                tag={{ id: `${id}.tag`, className: 'pr-0' }}
                className='3xl:max-w-screen-2xl mx-auto'
                padding={padding}
            >
                <div className='md:w-[420px] pt-9 md:pt-0'>
                    <FormattedMessage id={id} tagName='h2' />
                </div>
            </SectionWithTag>

            <div className='side-padding 3xl:max-w-screen-2xl mx-auto'>
                <Waypoint onEnter={() => setVisible(true)}>
                    {/*<div className="flex">*/}
                    <div className='grid py-9 md:py-20 lg:grid-cols-3 gap-y-8 md:gap-x-6 xl:gap-x-8 2xl:gap-x-12'>
                        {solutionCards.map((card, index) => (
                            <div
                                key={card.id}
                                style={{
                                    transform: visible
                                        ? 'translate3d(0px, 0px, 0px)'
                                        : 'translate3d(0px, 200px, 0px)',
                                    opacity: visible ? 1 : 0,
                                    transitionDelay: `${300 * (index + 1)}ms`,
                                }}
                                className='transition ease-out duration-1000'
                            >
                                <SolutionCard solution={card} />
                            </div>
                        ))}
                    </div>
                </Waypoint>
            </div>
        </div>
    )
}

export default NewEra
